module.exports = __webpack_public_path__ + "img/internet-society-isoc.27f79e5e.png";